export class InstitucionalModel {

    constructor(
      public sgItemMenu?: string,
      public caminho?: string,
      public dsItemMenu?: string,
      public idItemMenu?: number,
      public cpf?: string,
    ) {
    }
  }




// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/institucional.model.ts